import { Card, Grid, Group, Text } from '@mantine/core';
import FlowStepIcon from './FlowStepIcon';

const getStyle = (disabled) => ({
  background: 'white',
  cursor: disabled ? 'not-allowed' : 'move',
  opacity: disabled ? 0.6 : 1,
});

const FlowSidebarItem = ({ type, data, disabled }) => {
  const onDragStart = (event) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    event.dataTransfer.setData('application/reactflow', JSON.stringify({ type, data }));
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <Grid.Col span={6}>
      <Card style={getStyle(disabled)} draggable={!disabled} onDragStart={onDragStart} withBorder p="xs">
        <Group gap="xs" wrap="nowrap" justify="center">
          <FlowStepIcon icon={data.custom.key} />
          <Text size="sm">{data.label}</Text>
        </Group>
      </Card>
    </Grid.Col>
  );
};

export default FlowSidebarItem;
